import { render, staticRenderFns } from "./eArticle.vue?vue&type=template&id=5a54e411&"
import script from "./eArticle.vue?vue&type=script&lang=js&"
export * from "./eArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports